import { regex } from 'react-admin'

export const slugValidate = regex(
  /^[a-z_-][a-z0-9_-]*$/,
  'O campo só pode receber: caracteres alphanuméricos, "-" ou "_"',
)

export const numberValidate = regex(
  /^[0-9]*$/,
  'O campo só pode receber: caracteres numéricos',
)
